import { render, staticRenderFns } from "./BirthOfDayCalendar.vue?vue&type=template&id=f23729d0&scoped=true&"
import script from "./BirthOfDayCalendar.vue?vue&type=script&lang=js&"
export * from "./BirthOfDayCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BirthOfDayCalendar.vue?vue&type=style&index=0&id=f23729d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23729d0",
  null
  
)

export default component.exports